module.exports = __webpack_public_path__ + "img/icon_nav1_active.87a2c8a5.ca0533e1.svg";